import { useTranslation } from 'react-i18next'
import { TRADE_STATUS, TRADE_TYPE } from '../../types'

interface Props {
  status: TRADE_STATUS
  style: any
  tradeType: TRADE_TYPE
}

const getStatusI18n = (status: TRADE_STATUS, tradeType: TRADE_TYPE) => {
  const { t } = useTranslation()
  const i18nKeyMap = {
    unbroadcast: 'tokenlon_exchange_broadcast',
    pending: 'tokenlon_exchange_pending',
    success:
      tradeType === TRADE_TYPE.INSTANT ? 'exchange_success' : 'trade_success',
    failed: 'packing_failed',
  }
  return t(i18nKeyMap[status] ?? i18nKeyMap.unbroadcast)
}

const StatusItem: React.FC<Props> = (props) => {
  const { status, style, tradeType } = props
  return (
    <p
      className={`status-text ${style} ${
        status === 'pending' ? 'packing' : status === 'success' ? 'success' : ''
      }`}
    >
      {getStatusI18n(status, tradeType)}
    </p>
  )
}

export default StatusItem
